import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface ItemLotResponse {
    itemlots_code?: string | null;
    itemlots_lot?: string | null;
    itemlots_loc?: string | null;
    itemlots_desc?: string | null;
    itemlots_selling?: number | null;
    itemlots_cost?: number | null;
    itemlots_active?: boolean | null;
    itemlots_barcode?: string | null;
    itemlots_group?: string | null;
    itemlots_sih?: number | null;
}

export const getAllItemLots = async (options: { excludeRawItems?: boolean } = {}): Promise<ItemLotResponse[]> => {
    try {
        const response: ApiResponse<ItemLotResponse[] | null> = (
            await apiClient.get("/pos_itemlots/all", {
                params: options.excludeRawItems ? { exclude_raw_items: true } : undefined,
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data || [];
    } catch (error: any) {
        if (error?.response?.status === 401) {
            throw new Error("Not authorized to load items. Please sign in with backend authentication.");
        }

        if (error?.response?.data?.detail) {
            const detail = error.response.data.detail;
            const message = typeof detail === 'string' ? detail : JSON.stringify(detail);
            throw new Error(message);
        }

        throw new Error("Failed to fetch items");
    }
};